import classNames from 'classnames'
import { When } from 'react-if'
import { EyebrowMD } from '@/atoms/Text'
import { formatContentRating } from '@/services/ContentRatingService'
import { Maybe } from '@/utils/types'

interface ContentRatingBadgeProps {
  contentRating?: Maybe<string>
  className?: string
}

export const ContentRatingBadge: React.FC<ContentRatingBadgeProps> = ({ contentRating, className }) => {
  const formattedRating = formatContentRating(contentRating)
  return (
    <When condition={formattedRating && formattedRating?.length > 0}>
      <EyebrowMD className={classNames('w-fit whitespace-nowrap rounded border px-1', className)}>
        {formattedRating}
      </EyebrowMD>
    </When>
  )
}
